import React from 'react';
import styled from 'styled-components/macro';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { DescriptionText, HighlightText, BrandedPillButton } from './styles';

import { DESKTOP, TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';
import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';
import { useStaticSplashContent } from './content/useStaticSplashContent';
import { STATIC_SPLASH_INTRO } from 'src/client/constants/joinCampaigns';

export const Outro = () => {
  const [href] = useJoinUrl({ campaign: STATIC_SPLASH_INTRO });
  const showSfwSite = useShowSfwSite();
  const { outro } = useStaticSplashContent();

  const smallTagline = showSfwSite ? outro.smallTaglineNonNude : outro.smallTagline;

  return (
    <Wrapper>
      <HighlightText>{outro.largeTagline}</HighlightText>
      <StyledDescriptionText>{smallTagline}</StyledDescriptionText>
      <BrandedPillButton as="a" href={href} data-tagmanager-event="join_cta">
        {outro.buttonText}
      </BrandedPillButton>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 10px;
  justify-items: center;
  text-align: center;
  padding: 0 5px;
  margin-bottom: 30px;

  @media ${TABLET_PORTRAIT} {
    padding: 30px 10px;
    gap: 20px;
  }

  @media ${DESKTOP} {
    gap: 30px;
  }
`;

const StyledDescriptionText = styled(DescriptionText)`
  text-align: center;
`;
